<template>
  <component :is="tag" class="element" :class="{ show: show }"
    ><slot
  /></component>
</template>
<script setup lang="ts">
interface Props {
  delay?: number;
  tag?: string;
}
const props = defineProps({
  delay: { default: 10 },
  tag: { default: 'p' }
});
const show = ref(false);
let timeout;
onMounted(() => {
  timeout = setTimeout(() => {
    show.value = true;
  }, props.delay);
});
onUnmounted(() => {
  clearTimeout(timeout);
});
</script>
<style lang="scss" scoped>
.element {
  transform: translateY(10px);
  transition: opacity 200ms $ease-in-quad, transform 200ms $ease-out-quad;
  opacity: 0;
  &.show {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
